import { createContext } from 'react';
import { Artwork, Player, Round, SessionData } from '../API';
import { Reaction } from '../components/Controls/ReactionsBar';

interface HostSessionState {
  state: 'initializing' | 'loading' | 'connected' | 'disconnected';

  currentRound?: Round;
  artwork: Artwork[];

  players: Player[];
  reactions: Reaction[];
  session?: SessionData;
  sessionId: string;

  setSharingPlayer(playerId: string): void;
  startSession(): Promise<void>;
  nextGame(): Promise<void>;
  endSession(): Promise<void>;
  setEnding(): Promise<void>;
}

export const HostSessionContext = createContext<HostSessionState>({} as HostSessionState);
